export default __webpack_public_path__ + "static/media/experience-tour_choices-questions.810957dd.jpg";